var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"collapseRef",staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{staticClass:"bap_collapse-collapsible",style:({
      justifyContent: _vm.labelAlign,
      justifyItems: _vm.labelAlign,
      textAlign: _vm.labelAlign,
    }),on:{"click":_vm.handleCollapseToggle}},[_c('div',{staticClass:"bap_collapse-collapsible-label"},[(_vm.hasLabelSlot)?_vm._t("label"):_vm._e(),_vm._v("\n      "+_vm._s(!_vm.hasLabelSlot ? _vm.label : null)+"\n       \n      "),_c('i',{staticClass:"fa fa-caret-down",class:{ collapsed: !_vm.isCollapsed }})],2)]),_vm._v(" "),_c('transition',{attrs:{"name":"roll"},on:{"after-enter":_vm.scrollIntoView,"before-leave":_vm.beforeLeave}},[(!_vm.isCollapsed)?_c('div',{staticClass:"collapse-content",style:({
        justifyContent: _vm.labelAlign,
        justifyItems: _vm.labelAlign,
        textAlign: _vm.labelAlign,
      })},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }